import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const StyledModalBackground = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 2;
`;

const StyledBottomSheet = styled.div`
  z-index: 3;
  position: fixed;
  width: 80%;
  height: fit-content;
  max-height: 90%;
  &::-webkit-scrollbar {
    display: none;
  }
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1rem 1rem 0 0;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  text-align: center;
  & > .btns_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 46px;
    line-height: 46px;
    & > div {
      text-align: center;
      width: 50%;
    }
    & > .cancel {
      border-right: 1px solid rgba(102, 102, 102, 1);
    }
    & > .ok {
      color: #00c88c;
    }
  }
`;

const StyledBottomSheetContent = styled.div`
  min-height: 12vh;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(102, 102, 102, 1);
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 1);
  border-radius: 12px 12px 0px 0px;

  & > div {
    font-weight: 500;
    font-size: 16px;
    line-height: 1.7rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    color: #0d0d0d;
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
  }
`;

function BtnsModal({ closeModal, children, navi, onOk }) {
  const navigate = useNavigate();
  /**모바일 기종 분기처리 (ios, 안드로이드, 그 외) */
  // const [phoneType, setPhoneType] = useState();
  // function checkMobile() {
  var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

  //   if (varUA.indexOf("android") > -1) {
  //     //안드로이드
  //     setPhoneType("android");
  //     return "android";
  //   } else if (
  //     varUA.indexOf("iphone") > -1 ||
  //     varUA.indexOf("ipad") > -1 ||
  //     varUA.indexOf("ipod") > -1
  //   ) {
  //     //IOS
  //     setPhoneType("ios");
  //     return "ios";
  //   } else {
  //     //아이폰, 안드로이드 외
  //     setPhoneType("other");
  //     return "other";
  //   }
  // }
  // useEffect(() => {
  //   checkMobile();
  // }, []);

  const clickOk = () => {
    closeModal();
    onOk();
    if (navi === true) {
      // if (phoneType === "ios") {
      //   window.webkit.messageHandlers.movusCallBack.postMessage({
      //     command: "back",
      //   });
      // } else {
      //   // window.androidWebViewApi.movusCallBack({ command: "back" });
      //   window.postMessageToAndroid.movusCallBack({ command: "back" });
      // }
      // navigate(navi)
      if (varUA.indexOf("android") > -1) {
        //안드로이드
        window.postMessageToAndroid.movusCallBack("back");
        // setPhoneType("android");
        return "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1
      ) {
        //IOS
        window.webkit.messageHandlers.movusCallBack.postMessage({
          command: "back",
        });
        // setPhoneType("ios");
        return "ios";
      } else {
        window.postMessageToAndroid.movusCallBack("back");
        //아이폰, 안드로이드 외
        // setPhoneType("other");
        return "other";
      }
    }
  };
  return (
    <>
      <StyledModalBackground />
      <StyledBottomSheet>
        <StyledBottomSheetContent>
          <div>{children}</div>
        </StyledBottomSheetContent>
        <div className="btns_wrap">
          <div className="cancel" onClick={closeModal}>
            취소
          </div>
          <div className="ok" onClick={clickOk}>
            확인
          </div>
        </div>
      </StyledBottomSheet>
    </>
  );
}

export default BtnsModal;
